import { z } from 'zod';
import { baseComponentSchema } from '../component-base.schemas';

const hexColorRegex = /^#[0-9A-Fa-f]{6}$/;

export const blogPreviewCustomColorsSchema = z
  .object({
    background: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
    title: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
    subtitle: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
    cardBackground: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
    cardTitle: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
    cardExcerpt: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
    linkColor: z.string().regex(hexColorRegex, 'Invalid hex color').optional(),
  })
  .optional();

export const blogPreviewDataSchema = z.object({
  title: z.string().max(200, 'Title too long').default('From Our Blog'),
  subtitle: z.string().max(500, 'Subtitle too long').optional(),
  maxPosts: z.number().int().min(1).max(6).default(3),
  showExcerpt: z.boolean().default(true),
  showDate: z.boolean().default(true),
  showFeaturedImage: z.boolean().default(true),
  linkText: z.string().max(50).default('Read more'),
  customColors: blogPreviewCustomColorsSchema,
});

export const blogPreviewComponentSchema = baseComponentSchema.extend({
  type: z.literal('blog-preview'),
  data: blogPreviewDataSchema,
});

export type BlogPreviewCustomColors = z.infer<typeof blogPreviewCustomColorsSchema>;
export type BlogPreviewData = z.infer<typeof blogPreviewDataSchema>;
export type BlogPreviewComponent = z.infer<typeof blogPreviewComponentSchema>;
